import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CATEGORY_ICONS } from "@/lib/constants";
import { useLang } from "@/lib/lang";

export default function FiltersPanel({ categories, active, onToggle, onAll, onNone }) {
  const { t, lang } = useLang();
  return (
    <div className="glass rounded-2xl p-5 w-72" data-testid="filters-panel">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-serif-mystery text-xl text-[#8b6f3d]">{t("filters")}</h3>
        <div className="flex gap-1">
          <button
            onClick={onAll}
            data-testid="filter-all-btn"
            className="text-[10px] font-mono-data uppercase tracking-wider text-zinc-500 hover:text-[#8b6f3d] px-2 py-1 rounded transition-colors"
          >
            {t("filterAll")}
          </button>
          <button
            onClick={onNone}
            data-testid="filter-none-btn"
            className="text-[10px] font-mono-data uppercase tracking-wider text-zinc-500 hover:text-[#8b6f3d] px-2 py-1 rounded transition-colors"
          >
            {t("filterNone")}
          </button>
        </div>
      </div>
      <ScrollArea className="max-h-[60vh] pr-2">
        <div className="space-y-2">
          {categories.map((cat) => (
            <label
              key={cat.key}
              className="flex items-center gap-3 py-2 px-2 rounded-lg hover:bg-zinc-50 cursor-pointer transition-colors"
              data-testid={`filter-${cat.key}-row`}
            >
              <Checkbox
                checked={active.includes(cat.key)}
                onCheckedChange={() => onToggle(cat.key)}
                data-testid={`filter-${cat.key}-checkbox`}
                className="border-zinc-400 data-[state=checked]:bg-[#8b6f3d] data-[state=checked]:border-[#8b6f3d]"
              />
              <span
                className="w-2.5 h-2.5 rounded-full shrink-0"
                style={{ background: cat.color, boxShadow: `0 0 8px ${cat.color}55` }}
              />
              <span className="text-lg leading-none">{CATEGORY_ICONS[cat.key]}</span>
              <span className="text-sm text-zinc-800 flex-1">{cat[lang]}</span>
            </label>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
